export type CursorAction = 'SET_LEFT_ARROW' | 'SET_RIGHT_ARROW' | 'SET_VIEW' | 'SET_DRAGGABLE';
export type PointerVariant = 'view' | 'arrowLeft' | 'arrowRight';

export const pointerEventName = 'setPointer';

const createEvent = (event: CursorAction, payload: boolean): CustomEvent => {
  return new CustomEvent(pointerEventName, {
    detail: {
      cursor: event,
      appearance: payload,
    },
  });
};

export const pointer = (node: HTMLElement, variant: PointerVariant) => {
  const handleSetEvent = (): void => {
    switch (variant) {
      case 'arrowLeft':
        document.dispatchEvent(createEvent('SET_LEFT_ARROW', true));
        break;
      case 'arrowRight':
        document.dispatchEvent(createEvent('SET_RIGHT_ARROW', true));
        break;
      case 'view':
        document.dispatchEvent(createEvent('SET_VIEW', true));
        break;
    }
  };
  const handleUnsetEvent = (): void => {
    switch (variant) {
      case 'arrowLeft':
        document.dispatchEvent(createEvent('SET_LEFT_ARROW', false));
        break;
      case 'arrowRight':
        document.dispatchEvent(createEvent('SET_RIGHT_ARROW', false));
        break;
      case 'view':
        document.dispatchEvent(createEvent('SET_VIEW', false));
        break;
    }
  };

  node.addEventListener('mouseenter', handleSetEvent, true);
  node.addEventListener('mouseleave', handleUnsetEvent, true);
  return {
    destroy() {
      node.removeEventListener('mouseenter', handleSetEvent, true);
      node.removeEventListener('mouseleave', handleUnsetEvent, true);
    },
  };
};
